module.exports = __webpack_public_path__ + "static/product-6-2d50088c5afa7e43418a465e50d62e13.jpeg";